import { Link } from "react-router";
import type { ProductAuthor } from "@jipraks/shared";
import { authorsCopy } from "@client/locales/id/authors";
import { AuthorAvatar } from "./AuthorAvatar";

/** "oleh <author>" under a product title, linking to the profile. */
export function AuthorByline({ author }: { author: ProductAuthor }) {
  return (
    <Link
      to={`/authors/${author.slug}`}
      className="group/byline inline-flex min-h-11 max-w-full items-center gap-3 self-start rounded-full border border-border-default bg-surface py-1.5 pr-4 pl-1.5 transition-colors duration-200 ease-expo-out hover:border-border-hover hover:bg-surface-hover"
    >
      <AuthorAvatar name={author.name} avatarUrl={author.avatarUrl} size="sm" />
      <span className="min-w-0 truncate text-sm text-foreground-muted">
        {authorsCopy.by}{" "}
        <span className="font-medium text-foreground group-hover/byline:text-accent-bright">{author.name}</span>
        {author.headline && <span className="hidden sm:inline"> · {author.headline}</span>}
      </span>
    </Link>
  );
}
